import React, { useState, useEffect } from "react";
import { Box, Typography, Avatar, CardContent } from "@mui/material";

import { API_BASE_URL } from "../../../apiConfig";
import axios from "axios";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LinkIcon from "@mui/icons-material/Link";

export default function ArticleCard({ carId, onClose }) {
  const [articleData, setArticleData] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setError(null);
      setIsLoading(true);
      try {
        const response = await axios.get(
          `${API_BASE_URL}Article/Find/${carId}`
        );
        setArticleData(response.data);
        setIsLoading(false);
      } catch (err) {
        setError("Failed to fetch car data");
      }
    };

    fetchData();
  }, [carId]);

  if (isLoading) {
    return <div>..جاري التحميل</div>;
  }
  return (
    <div
      dir="ltr"
      style={{
        width: "100%",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        borderRadius: "5px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Avatar
          src={articleData?.imageURL || ""}
          sx={{ width: 300, height: 200 }}
          alt={articleData?.title || "N/A"}
        />
      </Box>
      <CardContent sx={{ textAlign: "right", mt: 2 }}>
        {error ? (
          <Typography color="error" sx={{ textAlign: "right" }}>
            {error}
          </Typography>
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                mb: 2,
              }}
            >
              <LocalGroceryStoreIcon sx={{ ml: 1, color: "blue" }} />
              <Typography variant="body1" dir="rtl">
                <strong>اسم المقال:</strong> {articleData?.title || "N/A"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row-reverse",
                alignItems: "center",
                mb: 2,
              }}
            >
              <LinkIcon sx={{ ml: 1, color: "blue" }} />
              <Typography variant="body1">
                <strong>اسم الرابط:</strong> {articleData?.slug || "N/A"}
              </Typography>
            </Box>
          </>
        )}
      </CardContent>
    </div>
  );
}
